/**
 * Hindi profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Hindi
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 101
 */

export const HI = {
  "metadata": {
    "name": "Hindi",
    "code": "hi",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 101
  },
  "words": [
    {
      "word": "बहन की चूत",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual"
      ],
      "variations": [
        "bahan ki choot",
        "behan ki chut",
        "bhen ki choot"
      ],
      "case_sensitive": false,
      "context_notes": "बहन की चूत (bahan ki choot): Sister's pussy",
      "target_type": "individual"
    },
    {
      "word": "बहनचोद",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "extremely_vulgar"
      ],
      "variations": [
        "bc",
        "बहनचोद",
        "bhnchod",
        "bahanchod",
        "b@hench0d"
      ],
      "case_sensitive": false,
      "context_notes": "Sister-fucker, extremely severe family and sexual insult",
      "target_type": "individual"
    },
    {
      "word": "भोसड़ी के",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar"
      ],
      "variations": [
        "भोसड़ी",
        "bhosdi",
        "bhosdike",
        "bhosri",
        "b**sdi"
      ],
      "case_sensitive": false,
      "context_notes": "Cunt-related insult, extremely vulgar reference to female genitalia",
      "target_type": "individual"
    },
    {
      "word": "भोसड़ी बगान",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "bhosdi bagan",
        "bhosadi baagan"
      ],
      "case_sensitive": false,
      "context_notes": "भोसड़ी बगान (bhosdi bagan): Cunt garden",
      "target_type": "individual"
    },
    {
      "word": "बूर",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "bur",
        "burr",
        "buur",
        "b00r"
      ],
      "case_sensitive": false,
      "context_notes": "बूर (bur): Pussy",
      "target_type": "individual"
    },
    {
      "word": "चोद",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual"
      ],
      "variations": [
        "chod",
        "chhod",
        "chodd",
        "chodh",
        "ch0d"
      ],
      "case_sensitive": false,
      "context_notes": "चोद (chod): Fuck",
      "target_type": "individual"
    },
    {
      "word": "चोदना",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual"
      ],
      "variations": [
        "chodna",
        "chhodna",
        "chudna",
        "chudwana"
      ],
      "case_sensitive": false,
      "context_notes": "चोदना (chodna): To fuck",
      "target_type": "individual"
    },
    {
      "word": "चोदू",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual"
      ],
      "variations": [
        "chodu",
        "chodu",
        "ch0du",
        "chodoo"
      ],
      "case_sensitive": false,
      "context_notes": "चोदू (chodu): Fucker",
      "target_type": "individual"
    },
    {
      "word": "चूत",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "choot",
        "chut",
        "chute",
        "ch00t",
        "choot"
      ],
      "case_sensitive": false,
      "context_notes": "चूत (choot): Pussy/Cunt",
      "target_type": "individual"
    },
    {
      "word": "चुदाई",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chudai",
        "chudaai",
        "choodai",
        "ch00dai"
      ],
      "case_sensitive": false,
      "context_notes": "चुदाई (chudai): Fucking",
      "target_type": "individual"
    },
    {
      "word": "चुदवाने",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chudwane",
        "chudwaane",
        "chudvane"
      ],
      "case_sensitive": false,
      "context_notes": "चुदवाने (chudwane): Get fucked",
      "target_type": "individual"
    },
    {
      "word": "चुतमारिके",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chutmarike",
        "chutmaarike"
      ],
      "case_sensitive": false,
      "context_notes": "चुतमारिके (chutmarike): Cunt reference",
      "target_type": "individual"
    },
    {
      "word": "गांड मरा",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "gaand mara",
        "gand mara",
        "gaand maraa"
      ],
      "case_sensitive": false,
      "context_notes": "गांड मरा (gaand mara): Fuck your ass",
      "target_type": "individual"
    },
    {
      "word": "लंड चूस",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "lund choos",
        "lauda choos",
        "lund chus"
      ],
      "case_sensitive": false,
      "context_notes": "लंड चूस (lund choos): Suck dick",
      "target_type": "individual"
    },
    {
      "word": "माँ चुदा",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual"
      ],
      "variations": [
        "maa chuda",
        "ma chuda",
        "maa choda"
      ],
      "case_sensitive": false,
      "context_notes": "माँ चुदा (maa chuda): Go fuck your mother",
      "target_type": "individual"
    },
    {
      "word": "मां का भोसड़ा",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual"
      ],
      "variations": [
        "maa ka bhosda",
        "ma ka bhosada",
        "maa ki bhosdi"
      ],
      "case_sensitive": false,
      "context_notes": "मां का भोसड़ा (maa ka bhosda): Mother's cunt",
      "target_type": "individual"
    },
    {
      "word": "मादरचोद",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "extremely_vulgar"
      ],
      "variations": [
        "मैडरचोद",
        "mc",
        "m@d@rch0d",
        "madarchod",
        "mc",
        "म***ड"
      ],
      "case_sensitive": false,
      "context_notes": "Motherfucker, most severe Hindi insult combining family and sexual abuse",
      "target_type": "individual"
    },
    {
      "word": "रांड",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "extremely_derogatory"
      ],
      "variations": [
        "रांडी",
        "raand",
        "r@and",
        "raandi"
      ],
      "case_sensitive": false,
      "context_notes": "Widow turned prostitute, extremely derogatory for women, historical context",
      "target_type": "individual"
    },
    {
      "word": "रंडी",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "derogatory"
      ],
      "variations": [
        "रंडिया",
        "रानी",
        "randi",
        "r@ndi",
        "rndee"
      ],
      "case_sensitive": false,
      "context_notes": "Whore/prostitute, extremely derogatory term for women",
      "target_type": "individual"
    },
    {
      "word": "रंडी का बच्चा",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "randi ka baccha",
        "raandi ka bachcha"
      ],
      "case_sensitive": false,
      "context_notes": "रंडी का बच्चा (randi ka baccha): Son of a whore",
      "target_type": "individual"
    },
    {
      "word": "साली रंडी",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "saali randi",
        "sali randi",
        "saali raandi"
      ],
      "case_sensitive": false,
      "context_notes": "साली रंडी (saali randi): Fucking whore",
      "target_type": "individual"
    },
    {
      "word": "भड़वा",
      "severity": 3,
      "categories": [
        "sexual",
        "male_specific",
        "pimp"
      ],
      "variations": [
        "भड़वे",
        "bhadwa",
        "bh@dwa",
        "bhadwe"
      ],
      "case_sensitive": false,
      "context_notes": "Pimp, male who exploits women sexually, implies moral corruption",
      "target_type": "individual"
    },
    {
      "word": "भड़वे",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "bhadwe",
        "bhadve",
        "bh@dwe"
      ],
      "case_sensitive": false,
      "context_notes": "भड़वे (bhadwe): Pimps (plural)",
      "target_type": "individual"
    },
    {
      "word": "छक्का",
      "severity": 3,
      "categories": [
        "homophobic",
        "gender",
        "transphobic"
      ],
      "variations": [
        "छक्के",
        "chakka",
        "ch@kka",
        "chhakka"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for homosexual/transgender, implies effeminacy",
      "target_type": "individual"
    },
    {
      "word": "छिनाल",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chhinal",
        "chinal",
        "chhinaal"
      ],
      "case_sensitive": false,
      "context_notes": "छिनाल (chhinal): Whore (old term)",
      "target_type": "individual"
    },
    {
      "word": "चूचे",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "chooche",
        "chuchi",
        "chuche",
        "chuchi"
      ],
      "case_sensitive": false,
      "context_notes": "चूचे (chooche): Breasts/Nipples",
      "target_type": "individual"
    },
    {
      "word": "चूतड़",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "chutad",
        "chutadd",
        "ch00tad"
      ],
      "case_sensitive": false,
      "context_notes": "चूतड़ (chutad): Buttocks/Ass",
      "target_type": "individual"
    },
    {
      "word": "चूतिया",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical",
        "derogatory"
      ],
      "variations": [
        "चुतिया",
        "chutia",
        "ch00tiya",
        "chutiaa",
        "च***या"
      ],
      "case_sensitive": false,
      "context_notes": "Cunt-related insult, implies stupidity through sexual organ reference",
      "target_type": "individual"
    },
    {
      "word": "चूतिए",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chutiye",
        "chutie",
        "ch00tiye"
      ],
      "case_sensitive": false,
      "context_notes": "चूतिए (chutiye): Cunts (plural)",
      "target_type": "individual"
    },
    {
      "word": "डफली",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "dafli",
        "daffli"
      ],
      "case_sensitive": false,
      "context_notes": "डफली (dafli): Pimp (regional)",
      "target_type": "individual"
    },
    {
      "word": "गांड",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gaand",
        "gand",
        "g@and",
        "gaandu"
      ],
      "case_sensitive": false,
      "context_notes": "गांड (gaand): Ass",
      "target_type": "individual"
    },
    {
      "word": "गांड फट",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gaand phat",
        "gand fat",
        "gaand phati"
      ],
      "case_sensitive": false,
      "context_notes": "गांड फट (gaand phat): Ass torn",
      "target_type": "individual"
    },
    {
      "word": "गांडिया",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gandiya",
        "gandiye",
        "g@ndiya"
      ],
      "case_sensitive": false,
      "context_notes": "गांडिया (gandiya): Asshole (variation)",
      "target_type": "individual"
    },
    {
      "word": "गांडिये",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gandiye",
        "g@ndiye"
      ],
      "case_sensitive": false,
      "context_notes": "गांडिये (gandiye): Assholes (plural)",
      "target_type": "individual"
    },
    {
      "word": "गांडू",
      "severity": 3,
      "categories": [
        "sexual",
        "homophobic",
        "anatomical"
      ],
      "variations": [
        "गांडु",
        "gandu",
        "g@ndu",
        "gandoo",
        "गं***"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole/gay insult, refers to anal anatomy with homophobic connotations",
      "target_type": "individual"
    },
    {
      "word": "घस्ती",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ghasti",
        "gasti",
        "ghassad",
        "gashti"
      ],
      "case_sensitive": false,
      "context_notes": "घस्ती (ghasti): Slut/Whore",
      "target_type": "individual"
    },
    {
      "word": "गोटे",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gote",
        "gotey",
        "g0te"
      ],
      "case_sensitive": false,
      "context_notes": "गोटे (gote): Testicles/Balls",
      "target_type": "individual"
    },
    {
      "word": "हरामी",
      "severity": 3,
      "categories": [
        "religious",
        "derogatory",
        "illegitimate_birth"
      ],
      "variations": [
        "हरामजादा",
        "harami",
        "haramzada",
        "h@rami",
        "हरामख़ोर"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard, illegitimate birth insult with religious/moral implications",
      "target_type": "individual"
    },
    {
      "word": "हरामजादा",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "haramzada",
        "haramjada",
        "haraamzada",
        "haramzaada"
      ],
      "case_sensitive": false,
      "context_notes": "हरामजादा (haramzada): Illegitimate child/Bastard",
      "target_type": "individual"
    },
    {
      "word": "हिजड़ा",
      "severity": 3,
      "categories": [
        "lgbtq"
      ],
      "variations": [
        "hijra",
        "hijda",
        "hijada",
        "hijade"
      ],
      "case_sensitive": false,
      "context_notes": "हिजड़ा (hijra): Transgender slur",
      "target_type": "individual"
    },
    {
      "word": "झाट",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "jhaat",
        "jhat",
        "jh@@t",
        "jhaat"
      ],
      "case_sensitive": false,
      "context_notes": "झाट (jhaat): Pubic hair/Nothing",
      "target_type": "individual"
    },
    {
      "word": "कमजात",
      "severity": 3,
      "categories": [
        "caste"
      ],
      "variations": [
        "kamjat",
        "kamjaat",
        "k@mjaat"
      ],
      "case_sensitive": false,
      "context_notes": "कमजात (kamjat): Low caste/Lowlife",
      "target_type": "individual"
    },
    {
      "word": "कंजर",
      "severity": 3,
      "categories": [
        "sexual",
        "caste"
      ],
      "variations": [
        "kanjar",
        "kanjra",
        "k@njar"
      ],
      "case_sensitive": false,
      "context_notes": "कंजर (kanjar): Lowlife/Prostitute community slur",
      "target_type": "individual"
    },
    {
      "word": "कुत्ते की औलाद",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "kutte ki aulad",
        "kutte ki aulaad"
      ],
      "case_sensitive": false,
      "context_notes": "कुत्ते की औलाद (kutte ki aulad): Dog's offspring",
      "target_type": "individual"
    },
    {
      "word": "कुत्ती",
      "severity": 3,
      "categories": [
        "animal_insult",
        "female_specific",
        "derogatory"
      ],
      "variations": [
        "कुतिया",
        "kutti",
        "kutiya",
        "k00tti"
      ],
      "case_sensitive": false,
      "context_notes": "Female dog/bitch, specifically targeting women with animal comparison",
      "target_type": "individual"
    },
    {
      "word": "लौड़ा",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "लंड",
        "lauda",
        "loda",
        "l@uda",
        "lund"
      ],
      "case_sensitive": false,
      "context_notes": "Penis, male anatomical reference used as general insult",
      "target_type": "general"
    },
    {
      "word": "लौड़े पे",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "laude pe",
        "lode pe",
        "laude pay"
      ],
      "case_sensitive": false,
      "context_notes": "लौड़े पे (laude pe): On dick (dismissive)",
      "target_type": "individual"
    },
    {
      "word": "लोडू",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "lodu",
        "lodoo",
        "l0du",
        "laudo"
      ],
      "case_sensitive": false,
      "context_notes": "लोडू (lodu): Dick-head",
      "target_type": "individual"
    },
    {
      "word": "वेश्या",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "veshya",
        "veshyaa",
        "v3shya"
      ],
      "case_sensitive": false,
      "context_notes": "वेश्या (veshya): Prostitute (formal)",
      "target_type": "individual"
    },
    {
      "word": "बदतमीज",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "badtameez",
        "badtamiz",
        "b@dtameez"
      ],
      "case_sensitive": false,
      "context_notes": "बदतमीज (badtameez): Ill-mannered",
      "target_type": "individual"
    },
    {
      "word": "बकचोद",
      "severity": 2,
      "categories": [
        "family_honor",
        "scatological"
      ],
      "variations": [
        "bakchod",
        "bakchodd",
        "bakchodi",
        "b@kchod"
      ],
      "case_sensitive": false,
      "context_notes": "बकचोद (bakchod): Bullshitter",
      "target_type": "individual"
    },
    {
      "word": "बकलंड",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "bakland",
        "baklund",
        "b@kland"
      ],
      "case_sensitive": false,
      "context_notes": "बकलंड (bakland): Idiot (colloquial)",
      "target_type": "individual"
    },
    {
      "word": "बेवकूफ",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "bewakoof",
        "bevakoof",
        "bewkoof",
        "bevkoof",
        "bevkuf",
        "bewkuf"
      ],
      "case_sensitive": false,
      "context_notes": "बेवकूफ (bewakoof): Fool/Stupid",
      "target_type": "individual"
    },
    {
      "word": "बेवड़ा",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "bewda",
        "bevda",
        "bevdey",
        "bewday",
        "beuda"
      ],
      "case_sensitive": false,
      "context_notes": "बेवड़ा (bewda): Drunkard",
      "target_type": "individual"
    },
    {
      "word": "चल भाग",
      "severity": 2,
      "categories": [
        "sexual",
        "scatological"
      ],
      "variations": [
        "chal bhag",
        "chal bhaag",
        "chalbhag"
      ],
      "case_sensitive": false,
      "context_notes": "चल भाग (chal bhag): Fuck off",
      "target_type": "individual"
    },
    {
      "word": "चरसी",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "charsi",
        "ch@rsi",
        "charas"
      ],
      "case_sensitive": false,
      "context_notes": "चरसी (charsi): Druggie/Stoner",
      "target_type": "individual"
    },
    {
      "word": "गंदी",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gandi",
        "g@ndi",
        "gandee",
        "gandia"
      ],
      "case_sensitive": false,
      "context_notes": "गंदी (gandi): Dirty/Filthy",
      "target_type": "individual"
    },
    {
      "word": "गंवार",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "ganwar",
        "ganwaar",
        "g@nwar"
      ],
      "case_sensitive": false,
      "context_notes": "गंवार (ganwar): Uncultured/Boor",
      "target_type": "individual"
    },
    {
      "word": "गू",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "goo",
        "gu",
        "guu"
      ],
      "case_sensitive": false,
      "context_notes": "गू (goo): Shit",
      "target_type": "individual"
    },
    {
      "word": "गुस्ताख",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gustakh",
        "gustaakh",
        "g00stakh"
      ],
      "case_sensitive": false,
      "context_notes": "गुस्ताख (gustakh): Insolent",
      "target_type": "individual"
    },
    {
      "word": "हग",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "hag",
        "hugg",
        "h@g",
        "hagna"
      ],
      "case_sensitive": false,
      "context_notes": "हग (hag): Shit (verb)",
      "target_type": "individual"
    },
    {
      "word": "हगना",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "hagna",
        "hagana",
        "h@gna"
      ],
      "case_sensitive": false,
      "context_notes": "हगना (hagna): To shit",
      "target_type": "individual"
    },
    {
      "word": "जाहिल",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "jahil",
        "jaahil",
        "j@hil"
      ],
      "case_sensitive": false,
      "context_notes": "जाहिल (jahil): Ignorant/Barbaric",
      "target_type": "individual"
    },
    {
      "word": "जंगली",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "jangli",
        "janglee",
        "j@ngli"
      ],
      "case_sensitive": false,
      "context_notes": "जंगली (jangli): Savage/Wild",
      "target_type": "individual"
    },
    {
      "word": "कमीना",
      "severity": 2,
      "categories": [
        "derogatory",
        "character",
        "general"
      ],
      "variations": [
        "कमीने",
        "kamina",
        "kameena",
        "kam33na"
      ],
      "case_sensitive": false,
      "context_notes": "Scoundrel, mean person, character attack without specific vulgarity",
      "target_type": "individual"
    },
    {
      "word": "कमीने",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "kamine",
        "kamene",
        "kam33ne"
      ],
      "case_sensitive": false,
      "context_notes": "कमीने (kamine): Scoundrels (plural)",
      "target_type": "individual"
    },
    {
      "word": "कूड़ा",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "kooda",
        "kuda",
        "koora"
      ],
      "case_sensitive": false,
      "context_notes": "कूड़ा (kooda): Trash/Garbage",
      "target_type": "individual"
    },
    {
      "word": "कुत्ता",
      "severity": 2,
      "categories": [
        "animal_insult",
        "derogatory",
        "general"
      ],
      "variations": [
        "कुत्ते",
        "कुत्ती",
        "kutta",
        "kutte",
        "kutiya"
      ],
      "case_sensitive": false,
      "context_notes": "Dog, common insult implying low status, cowardice, or servility",
      "target_type": "individual"
    },
    {
      "word": "कुत्ते का बच्चा",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "kutte ka baccha",
        "kuttey ka bachcha"
      ],
      "case_sensitive": false,
      "context_notes": "कुत्ते का बच्चा (kutte ka baccha): Son of a dog",
      "target_type": "individual"
    },
    {
      "word": "मरना",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "mar ja",
        "maar dala",
        "marr jaa"
      ],
      "case_sensitive": false,
      "context_notes": "मरना (marna): Die (in context)",
      "target_type": "individual"
    },
    {
      "word": "मूत",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "moot",
        "muut",
        "m00t",
        "mootna"
      ],
      "case_sensitive": false,
      "context_notes": "मूत (moot): Urine/Piss",
      "target_type": "individual"
    },
    {
      "word": "मूतना",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "mootna",
        "mutna",
        "m00tna"
      ],
      "case_sensitive": false,
      "context_notes": "मूतना (mootna): To piss",
      "target_type": "individual"
    },
    {
      "word": "नालायक",
      "severity": 2,
      "categories": [
        "derogatory",
        "worthlessness",
        "family"
      ],
      "variations": [
        "नालायकी",
        "nalayak",
        "n@layak",
        "naalayak"
      ],
      "case_sensitive": false,
      "context_notes": "Worthless, useless person, often used by parents for children",
      "target_type": "individual"
    },
    {
      "word": "नालायकी",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "nalayaki",
        "naalayaki",
        "nalayakee"
      ],
      "case_sensitive": false,
      "context_notes": "नालायकी (nalayaki): Worthlessness",
      "target_type": "individual"
    },
    {
      "word": "नशेड़ी",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "nashedi",
        "nashedee",
        "n@shedi"
      ],
      "case_sensitive": false,
      "context_notes": "नशेड़ी (nashedi): Drug addict",
      "target_type": "individual"
    },
    {
      "word": "नीच",
      "severity": 2,
      "categories": [
        "caste"
      ],
      "variations": [
        "neech",
        "nich",
        "neecha"
      ],
      "case_sensitive": false,
      "context_notes": "नीच (neech): Low/Vile person",
      "target_type": "individual"
    },
    {
      "word": "पाद",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "paad",
        "pad",
        "paadna",
        "p@@d"
      ],
      "case_sensitive": false,
      "context_notes": "पाद (paad): Fart",
      "target_type": "individual"
    },
    {
      "word": "पेशाब",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "peshab",
        "peshaab",
        "p3shab"
      ],
      "case_sensitive": false,
      "context_notes": "पेशाब (peshab): Piss",
      "target_type": "individual"
    },
    {
      "word": "पेशाबी",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "peshabee",
        "peshaabi",
        "p3shabee"
      ],
      "case_sensitive": false,
      "context_notes": "पेशाबी (peshabee): Pisser",
      "target_type": "individual"
    },
    {
      "word": "फूहड़",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "phuhar",
        "foohar",
        "ph00har"
      ],
      "case_sensitive": false,
      "context_notes": "फूहड़ (phuhar): Vulgar/Obscene",
      "target_type": "individual"
    },
    {
      "word": "साला",
      "severity": 2,
      "categories": [
        "family_insult",
        "relationship",
        "mild"
      ],
      "variations": [
        "साले",
        "saala",
        "sala",
        "s@ala"
      ],
      "case_sensitive": false,
      "context_notes": "Brother-in-law, mild family-related insult, very common",
      "target_type": "individual"
    },
    {
      "word": "सुअर",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "suar",
        "su@r",
        "soor",
        "sowar"
      ],
      "case_sensitive": false,
      "context_notes": "सुअर (suar): Pig",
      "target_type": "individual"
    },
    {
      "word": "टट्टी",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "tatti",
        "tati",
        "t@tti",
        "tatty"
      ],
      "case_sensitive": false,
      "context_notes": "टट्टी (tatti): Shit/Feces",
      "target_type": "individual"
    },
    {
      "word": "ठरकी",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "tharki",
        "tarkee",
        "th@rki"
      ],
      "case_sensitive": false,
      "context_notes": "ठरकी (tharki): Pervert/Lecher",
      "target_type": "individual"
    },
    {
      "word": "बदमाश",
      "severity": 1,
      "categories": [
        "derogatory",
        "character",
        "mild"
      ],
      "variations": [
        "बदमाशी",
        "badmash",
        "b@dmash",
        "badmaashi"
      ],
      "case_sensitive": false,
      "context_notes": "Rascal, mischievous person, relatively mild character insult",
      "target_type": "individual"
    },
    {
      "word": "बकवास",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "bakwas",
        "bakwaas",
        "b@kwas"
      ],
      "case_sensitive": false,
      "context_notes": "बकवास (bakwas): Nonsense/Bullshit",
      "target_type": "individual"
    },
    {
      "word": "भक",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "bhak",
        "bhaag",
        "bhagg"
      ],
      "case_sensitive": false,
      "context_notes": "भक (bhak): Get lost",
      "target_type": "individual"
    },
    {
      "word": "भोंडा",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "bhonda",
        "bhonda",
        "bh0nda"
      ],
      "case_sensitive": false,
      "context_notes": "भोंडा (bhonda): Tacky/Vulgar",
      "target_type": "individual"
    },
    {
      "word": "चप्पल",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "chappal",
        "chappall",
        "ch@ppal"
      ],
      "case_sensitive": false,
      "context_notes": "चप्पल (chappal): Slipper (insult context)",
      "target_type": "individual"
    },
    {
      "word": "छी",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "chhi",
        "chhee",
        "chi",
        "chee"
      ],
      "case_sensitive": false,
      "context_notes": "छी (chhi): Disgusting/Yuck",
      "target_type": "individual"
    },
    {
      "word": "देहाती",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "dehati",
        "dehaati",
        "d3hati"
      ],
      "case_sensitive": false,
      "context_notes": "देहाती (dehati): Villager (derogatory urban use)",
      "target_type": "individual"
    },
    {
      "word": "धक्का",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "dhakka",
        "dhaka",
        "dhakke"
      ],
      "case_sensitive": false,
      "context_notes": "धक्का (dhakka): Push off (rude context)",
      "target_type": "individual"
    },
    {
      "word": "फालतू",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "faltu",
        "faaltu",
        "f@ltu",
        "phaltu"
      ],
      "case_sensitive": false,
      "context_notes": "फालतू (faltu): Useless/Waste",
      "target_type": "individual"
    },
    {
      "word": "गधा",
      "severity": 1,
      "categories": [
        "animal_insult",
        "intelligence",
        "mild"
      ],
      "variations": [
        "गधे",
        "gadha",
        "g@dha",
        "gadhe"
      ],
      "case_sensitive": false,
      "context_notes": "Donkey, implies stupidity, very common mild insult",
      "target_type": "individual"
    },
    {
      "word": "गंदगी",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gandagi",
        "gandgi",
        "g@ndagi"
      ],
      "case_sensitive": false,
      "context_notes": "गंदगी (gandagi): Filth",
      "target_type": "individual"
    },
    {
      "word": "घटिया",
      "severity": 1,
      "categories": [
        "caste"
      ],
      "variations": [
        "ghatiya",
        "ghattiya",
        "gh@tiya"
      ],
      "case_sensitive": false,
      "context_notes": "घटिया (ghatiya): Low quality/Cheap",
      "target_type": "individual"
    },
    {
      "word": "हट",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "hatt",
        "hat",
        "hut"
      ],
      "case_sensitive": false,
      "context_notes": "हट (hatt): Get away (rude)",
      "target_type": "individual"
    },
    {
      "word": "जूता",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "joota",
        "juta",
        "j00ta"
      ],
      "case_sensitive": false,
      "context_notes": "जूता (joota): Shoe (insult context)",
      "target_type": "individual"
    },
    {
      "word": "मूर्ख",
      "severity": 1,
      "categories": [
        "intelligence",
        "formal",
        "mild"
      ],
      "variations": [
        "मूर्खता",
        "murkh",
        "moorakh",
        "m00rkh"
      ],
      "case_sensitive": false,
      "context_notes": "Fool/idiot, formal term for lack of intelligence",
      "target_type": "individual"
    },
    {
      "word": "पागल",
      "severity": 1,
      "categories": [
        "mental_health",
        "derogatory",
        "mild"
      ],
      "variations": [
        "पगला",
        "pagal",
        "p@gal",
        "paagal"
      ],
      "case_sensitive": false,
      "context_notes": "Crazy/mad, mild insult questioning sanity, can be playful",
      "target_type": "individual"
    },
    {
      "word": "उल्लू का पट्ठा",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "ullu ka pattha",
        "ullu ke pathe",
        "ulloo ka patta"
      ],
      "case_sensitive": false,
      "context_notes": "उल्लू का पट्ठा (ullu ka pattha): Son of an owl/Idiot",
      "target_type": "individual"
    }
  ]
} as const

export type HIType = typeof HI
